import {AxiosResponse} from "axios";
import {BaseMutationOptions, BaseUseMutationResult, useBaseMutation} from "@bounce/shared/requests";
import {axiosReachInstance} from "../../ReachApiManager";
import {PROMOS_QUERY_KEY} from "../queryKeys";
import {ReachPromo} from "./types";

type OrderPromosVariables = {promo_ids: number[]};

const orderPromos = async (variables: OrderPromosVariables): Promise<ReachPromo[]> => {
  const response = await axiosReachInstance.put<ReachPromo[], AxiosResponse<ReachPromo[]>, OrderPromosVariables>(
    "/promos/order",
    variables
  );
  return response.data;
};

export const useOrderPromos = (
  options?: BaseMutationOptions<ReachPromo[], OrderPromosVariables>
): BaseUseMutationResult<ReachPromo[], OrderPromosVariables> => {
  return useBaseMutation<ReachPromo[], OrderPromosVariables>(orderPromos, {
    ...options,
    prefixKeysToInvalidate: () => [[PROMOS_QUERY_KEY]],
  });
};
